import React from 'react';

function Pagination({ totalItems, itemsPerPage, currentPage, onPageChange }) {
  if (itemsPerPage === 'all') return null;
  
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (totalPages <= 1) return null;

  return (
    <div className="pagination no-print" style={{display: 'flex', alignItems: 'center', gap: '1.5rem', margin: '2rem 0'}}>
      <button 
        className="secondary-btn"
        onClick={() => onPageChange(currentPage - 1)} 
        disabled={currentPage === 1}
        style={{padding: '0.4rem 1rem', fontSize: '0.85rem'}}
      >
        &larr; Previous
      </button>
      <span style={{fontSize: '0.9rem', color: 'var(--text-secondary)'}}>
        Page <strong>{currentPage}</strong> of {totalPages}
      </span>
      <button 
        className="secondary-btn"
        onClick={() => onPageChange(currentPage + 1)} 
        disabled={currentPage === totalPages}
        style={{padding: '0.4rem 1rem', fontSize: '0.85rem'}}
      >
        Next &rarr;
      </button>
    </div>
  );
}

export default Pagination;
